import { NavLink, Outlet } from "react-router-dom";
import {
  MainContent,
  SectionContainer,
  SectionWrapper,
  SidebarContainer,
  TabsContainer,
} from "./components";
import { useFeatures } from "@/contexts/FeaturesContext";

const tabDefs = [
  {
    label: "Preservations",
    value: "preservations",
  },
];

const Tabs = () => {
  return (
    <TabsContainer>
      {tabDefs.map((tab) => (
        <NavLink to={tab.value} key={tab.value}>
          <div className="tab">{tab.label}</div>
        </NavLink>
      ))}
    </TabsContainer>
  );
};

export const EdiscoveryContent = () => {
  const { hasFeatures, FEATURES } = useFeatures();
  const hasEdiscoveryFeatures = hasFeatures([FEATURES.EDISCOVERY_ALL_FEATURES]);

  if (!hasEdiscoveryFeatures) {
    return <div>Ediscovery features are not enabled</div>;
  }

  return (
    <SectionWrapper className={"ediscovery-section"}>
      <SectionContainer className="ediscovery-section-container">
        <SidebarContainer>
          <Tabs />
        </SidebarContainer>
        <MainContent className="ediscovery-content">
          <Outlet />
        </MainContent>
      </SectionContainer>
    </SectionWrapper>
  );
};
